import * as api from '@/api/give-course/inquiry'
import * as TYPES from './type';

export default {
  //问卷
  async getSKInquiryList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKInquiryList(paramets)
    commit(TYPES.SK_INQUIRY_LIST, { result })
    cb && cb()
  },
  //问卷详情
  async getSKInquiryDetails({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKInquiryDetails(paramets)
    commit(TYPES.SK_INQUIRY_DETAILS, { result })
    cb && cb()
  },
  //问卷编辑
  async putSKInquiryEdit({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKInquiryEdit(paramets)
    commit(TYPES.SK_INQUIRY_EDIT, { result })
    cb && cb()
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/inquiry/actions.js